import React from "react";
import Loader from "./Loader";

const FullPageLoader = ({ text = "Loading..." }) => {
  return (
    <div className="fullpage-loader">
      <div className="loader-content">
        <Loader text={text} />
      </div>
    </div>
  );
};

export default FullPageLoader;